import { useMutation } from '@tanstack/react-query';
import { AxiosRequestConfig } from 'axios';
import { useVigoToast } from 'src/@core/hooks/useVigoToast';
import { AttachmentDto, AttachmentModel, BaseModel } from 'src/models/attachment';
import { deleteAttachmentById, toggleAttachmentIsHidden } from 'src/services/attachment';

export const useAttachmentPanelMutations = () => {
  // Hooks
  const { vigoToast } = useVigoToast({});

  const deleteAttachmentMutation = useMutation({
    mutationFn: async (data: any) => {
      const deleteAttachmentToastId = vigoToast.loading('Deleting attachment');

      try {
        const reqBody: AxiosRequestConfig<BaseModel> = {
          data: { version: data.attachmentVersion }
        };

        const res = await deleteAttachmentById(data.attachmentDtoId, reqBody);

        vigoToast.success('Attachment deleted', { id: deleteAttachmentToastId });

        return Promise.resolve(res);
      } catch (e) {
        vigoToast.error('Error deleting attachment', { id: deleteAttachmentToastId });

        return Promise.reject(e);
      }
    }
  });

  const toggleFileVisibilityMutation = useMutation({
    mutationFn: async (data: AttachmentDto) => {
      const toggleFileVisibilityToastId = vigoToast.loading('Updating file visibility');

      try {
        const model: AttachmentModel = {
          fileType: data.fileType!,
          name: data.name!,
          uri: data.uri!,
          attachmentTypeId: data.attachmentTypeId,
          comment: data.comment,
          entityId: data.entityId,
          entityTypeId: data.entityTypeId,
          isHidden: data.isHidden,
          size: data.size,
          thumbnailUri: data.thumbnailUri,
          version: data.version
        };

        const res = await toggleAttachmentIsHidden(data.id!, model);

        vigoToast.success('File visibility updated', { id: toggleFileVisibilityToastId });

        return Promise.resolve(res);
      } catch (e) {
        vigoToast.error('Error updating file visibility', { id: toggleFileVisibilityToastId });

        return Promise.reject(e);
      }
    }
  });

  return { deleteAttachmentMutation, toggleFileVisibilityMutation };
};
